import { Injectable } from '@angular/core';
import { GuestRecipeBoxData } from './guest-recipe-box-data';
import { UserRecipeBoxData } from './user-recipe-box-data';
@Injectable()
export class RecipeBoxDataGateway {
    constructor(
        public guestData: GuestRecipeBoxData,
        public userData: UserRecipeBoxData
    ){

    }
    public getService(uid?): GuestRecipeBoxData|UserRecipeBoxData{
        return uid ? this.userData: this.guestData;
    };
}


// WEBPACK FOOTER //
// ./src/modules/recipes/providers/recipe-box-data-gateway.ts